<div class="row">
  <div class="col m-2">
    <div class="row" *ngIf="patCode>0 && visitSerial>0">
      <sanabel-patientBanner></sanabel-patientBanner>
    </div>
    <div class="row master-form">
      <div class="col">
        <div class="row" style="margin:5px;">
          <div class="col-2 form-group">
            <div>
              <sanabel-selectize appcode="1023" [(ngModel)]="_SearchParms.patCode" #patientSelectize [simpleView]="true"
                (clicked)="onPatientClicked($event)">
              </sanabel-selectize>
            </div>
          </div>
          <div class="col-2 form-group">
            <div>
              <sanabel-selectize appcode="1096" [(ngModel)]="_SearchParms.visitSerial" #visitSelectize
                [simpleView]="true" [SearchKeys]="{PatCode : _SearchParms.patCode}" [appcode]="1096"
                (clicked)="onVisitClicked($event)">
              </sanabel-selectize>
            </div>
          </div>
          <div class="col-2 form-group">
            <div>
              <sanabel-selectize appcode="14347" [(ngModel)]="_SearchParms.regPatServiceSerial" #serviceSelectize
                [required]="true"
                [SearchKeys]="{ ServiceType:this.serviceType, VisitSerial :_SearchParms.visitSerial}"
                [simpleView]="true" (clicked)="onServiceClicked($event)">
              </sanabel-selectize>
            </div>
          </div>
          <div class="col-2 form-group">
            <div>
              <sanabel-selectize appcode="890" [(ngModel)]="_SearchParms.hasReportFlag" #hasReportSelectize
                [simpleView]="true" (clicked)="onHasReportFlagClicked($event)">
              </sanabel-selectize>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <div class="input-group input-group-sm">
                <input class="form-control" placeholder="{{'From Date' | translate}}"
                  [(ngModel)]="_SearchParms.fromDate" name="fromDate" ngbDatepicker #fromDate="ngbDatepicker">
                <div class="input-group-addon" (click)="fromDate.toggle()">
                  <i class="fa fa-calendar"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <div class="input-group input-group-sm">
                <input class="form-control" placeholder="{{'To Date' | translate}}" [(ngModel)]="_SearchParms.toDate"
                  name="toDate" ngbDatepicker #toDate="ngbDatepicker">
                <div class="input-group-addon" (click)="toDate.toggle()">
                  <i class="fa fa-calendar"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-1 form-group">
            <div class="btn-group align-self-center">
              <button class="btn btn-primary" title="{{ 'SEARCH' | translate }}" placement="top" ngbTooltip="search "
                (click)="searchPatientServices()">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
  <div class="row">

    <div class="col-7">
      <div class="row">
        <!-- <button (click)="addNewReport()" type="button" class="mx-0 btn btn-outline-primary btn-lg btn-block mt-4 mb-2">
          {{'ADD New Report' |translate}}
          <i class="fa fa-plus fa-1x icons-style" aria-hidden="true" placement="left"
            ngbTooltip="{{ 'ADD New Report' | translate }}"></i>
        </button> -->
        <div class="col-12 p-2" *ngIf="regPatServiceSerial>0 && allPatientServices.length>0">
          <sanabel-selectize appcode="1135" [simpleView]="true" #htmlTemplate [(ngModel)]="emrHtmlTemplateSerial"
            [SearchKeys]="{'ReportType':100}" (clicked)="onTemplateSelect($event)"></sanabel-selectize>
        </div>
        <div class="col-12">
          <textarea style="direction: ltr;" name="textContent" class="form-control" [(ngModel)]="textContent" rows="20"
            cols="160" placeholder="Written by Dr:"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col" [ngClass]="{ disabledDiv: false }">
          <btns-ctrl #btnCtrl [appCodes]="[1,639]" (clicked)="onBtnClicked($event)"
            *ngIf="!emrHtmlReportSerial || emrHtmlReportSerial==0"></btns-ctrl>
          <btns-ctrl #btnCtrl [appCodes]="[565,639]" (clicked)="onBtnClicked($event)"
            *ngIf="emrHtmlReportSerial>0"></btns-ctrl>


        </div>
      </div>
    </div>
    <div class="col-5">
      <!-- <button type="button" class="mx-0 btn btn-outline-primary btn-lg btn-block mt-4 mb-2">
        {{'Patient Services List' |translate}}
      </button> -->
      <div class="form-group mt-2">
        <input type="text" class="form-control" placeholder="Filter Services" (keyup)="filterServices()"
          [(ngModel)]="filterText">
      </div>
      <div class="scroll">

        <table class="table table-bordered table-striped" style="text-align: center;">
          <thead class="ui-datatable-thead">
            <tr>
              <th style="width:1%;">{{ 'Action' | translate }} </th>
              <th style="width:33%;">{{ 'Visit Date' | translate }}</th>
              <th style="width:33%;">{{ 'Service Name' | translate }}</th>
              <th style="width:33%;">{{ 'Service Code' | translate }}</th>
            
            </tr>
          </thead>

          <tbody class="ui-datatable-data ui-widget-content">
            <tr class="ui-widget-content" *ngFor="let item of allPatientServices; index as indx">
              <td>
                <icon-action (clicked)="onPatServiceClick(item,$event)" [rowData]="item" [appCodes]="[404]">
                </icon-action>
              </td>
              <td>
                <strong style="color: rgb(136, 208, 237)">
                  (Ptn - {{item.patCode}})
                </strong>
                <strong>
                  {{item.startDate|date:'dd-MM-yyyy'}}
                </strong>

              </td>
              <td>
                <strong>
                  {{translate.currentLang == 'ar' ? item['serviceNameAr']:item['serviceNameEn']}}
                </strong>

                <br>
                <strong style="color: green;" *ngIf="item.emrHtmlReportSerial>0">
                  {{item['patReportStatus']}} (RS - {{item['emrHtmlReportSerial']}})
                </strong>
                <strong style="color: red;" *ngIf="!item.emrHtmlReportSerial">
                  ({{item['patReportStatus']}})
                </strong>
              </td>
              <td>
                <strong>
                  {{item.serviceId}}
                </strong>
                <strong style="color: blue;">
                  (ACN - {{item['regPatServiceSerial']}})
                </strong> <strong style="color: green;">
                  (VS - {{item['visitSerial']}})
                </strong>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>